export function camelizeKeys(obj: unknown): unknown {
  if (Array.isArray(obj)) {
    return obj.map(camelizeKeys)
  }
  if (obj !== null && typeof obj === "object") {
    const result: Record<string, unknown> = Object.create(null)
    for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
      if (key === "__proto__") continue
      const camelKey = key.replace(/_([a-z])/g, (_, c: string) =>
        c.toUpperCase()
      )
      result[camelKey] = camelizeKeys(value)
    }
    return result
  }
  return obj
}
